module.exports = __webpack_public_path__ + "static/email-d3c9b2039e3fd5e7036a9ed6084e0975.png";